<template>
  <div class="technicalsupport">
    <div class="header">
      <div class="title">我们提供的技术支持</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in list" :key="item.id">
          <div class="left">
            <img :src="item.logo" alt="" />
          </div>
          <div class="right">
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import technicalsupport1 from "../../../../assets/programme/technicalsupport1.png";
import technicalsupport2 from "../../../../assets/programme/technicalsupport2.png";
import technicalsupport3 from "../../../../assets/programme/technicalsupport3.png";
import technicalsupport4 from "../../../../assets/programme/technicalsupport4.png";
import technicalsupport5 from "../../../../assets/programme/technicalsupport5.png";
import technicalsupport6 from "../../../../assets/programme/technicalsupport6.png";

export default {
  setup() {
    return reactive({
      list: [
        {
          id: 1,
          title: "物业管理系统",
          text: "针对智慧化社区的特点，集成物业管理的相关系统",
          logo: technicalsupport1,
        },
        {
          id: 2,
          title: "智能硬件对接",
          text: "智能监控、智能门禁系统等以智能传感互联、人机交互、新型显示及大数据处理等新一代信息技术",
          logo: technicalsupport2,
        },
        {
          id: 3,
          title: "智慧财务对接",
          text: "支持多渠道收缴费，业务流程可自定义，财务数据高效排查，快速定位原因",
          logo: technicalsupport3,
        },
        {
          id: 4,
          title: "移动办公软件",
          text: "将软件、平台、硬件设备与通信技术完美结合，为用户单位解决各类现目前无法解决的问题",
          logo: technicalsupport4,
        },
        {
          id: 5,
          title: "数据统计分析",
          text: "数据接入、数据治理、数据碰撞和数据分析服务，软硬件相结合为社区业务应用提供整体服务",
          logo: technicalsupport5,
        },
        {
          id: 6,
          title: "社区商城",
          text: "实现消费者、商户之间的网上交易和在线电子支付以及各种商务活动",
          logo: technicalsupport6,
        },
      ],
    });
  },
};
</script>

<style scoped>
.technicalsupport {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
}
.body .list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.body .list .item {
  display: flex;
  align-items: center;
  margin-bottom: 80px;
}
.body .list .item .left img {
  width: 72px;
  margin-right: 40px;
}
.body .list .item .right {
  width: 224px;
}
.body .list .item .right .title {
  color: #333;
  font-size: 16px;
}
.body .list .item .right .text {
  margin-top: 10px;
  color: #495a6c;
  font-size: 14px;
}
</style>
